import React from 'react';
import { I18N_DEFAULT_NAMESPACE } from '../constants';
import { createI18N } from '../createI18N';
import { useLocale } from '../hooks/useLocale';

const i18n = createI18N();

export const I18NContext = React.createContext(i18n);

export function I18NProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const locale = useLocale();

  // Load translations
  if (!i18n.hasResourceBundle(locale, I18N_DEFAULT_NAMESPACE)) {
    i18n.changeLanguage(locale);
    i18n.loadNamespaces(I18N_DEFAULT_NAMESPACE);
  }

  return <I18NContext.Provider value={i18n}>{children}</I18NContext.Provider>;
}
